var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.064,
    height: 34.422,
    viewBox: "0 0 34.064 34.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b9ddff;}.b{fill:#0062c7;}.c{fill:#4baafc;}.d{fill:#aeadad;opacity:0.82;mix-blend-mode:multiply;isolation:isolate;}.e{fill:#feb05c;}.f{fill:#f1f7f1;}.g{fill:#faae5e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M150.051,115.566l-.191.039Z",
    transform: "translate(-140.275 -108.174)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M174.137,102.31c-.511.193-1.059.376-1.639.54C173.078,102.686,173.626,102.5,174.137,102.31Z",
    transform: "translate(-161.465 -95.766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.913,4.527C24.449,5.623,17.032,0,17.032,0S9.615,5.623.15,4.527c0,0-2.912,25.557,16.881,29.9C36.825,30.084,33.913,4.527,33.913,4.527ZM27.524,24.778a16.311,16.311,0,0,1-10.492,7.071h0C.2,28.16,2.674,6.423,2.674,6.423A18.477,18.477,0,0,0,6.063,6.5l.225.164L6.063,6.5A22.452,22.452,0,0,0,17.032,2.573,21.851,21.851,0,0,0,31.39,6.423S32.607,17.119,27.524,24.778Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M164.428,110.749c-.18.051-.365.1-.551.146C164.063,110.848,164.248,110.8,164.428,110.749Z",
    transform: "translate(-153.395 -103.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M198.131,68.942a18.926,18.926,0,0,0,4.359-2.28h0A18.926,18.926,0,0,1,198.131,68.942Z",
    transform: "translate(-185.459 -62.398)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M54.292,40.225a22.452,22.452,0,0,1-10.969,3.926l.225.164-.225-.164a18.478,18.478,0,0,1-3.389-.076S37.458,65.812,54.292,69.5h0a16.311,16.311,0,0,0,10.492-7.071c5.084-7.66,3.866-18.356,3.866-18.356A21.851,21.851,0,0,1,54.292,40.225Zm9.177,21.483a14.422,14.422,0,0,1-9.177,6.1h0v-.353h0V52.138h0V41.916a18.926,18.926,0,0,1-4.359,2.28c-.511.193-1.059.376-1.639.54-.18.051-.365.1-.551.146.186-.047.371-.095.551-.146.58-.164,1.128-.347,1.639-.54a18.926,18.926,0,0,0,4.359-2.28,19.327,19.327,0,0,0,12.7,3.405S68.084,54.924,63.469,61.708ZM46.845,45.083l.191-.039Z",
    transform: "translate(-37.26 -37.652)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M266.291,39.846h0V51.422h0V68.771h0v.4h0a16.332,16.332,0,0,0,10.393-6.91c5.226-7.683,3.989-18.558,3.989-18.558A21.887,21.887,0,0,1,266.291,39.846Z",
    transform: "translate(-249.259 -37.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M185.237,118.878h-.025v-1.56c0-3.092-2.271-5.622-5.046-5.622s-5.047,2.53-5.047,5.622v1.56h-.025a1.3,1.3,0,0,0-1.293,1.293v8.1a1.3,1.3,0,0,0,1.293,1.293h10.143a1.3,1.3,0,0,0,1.293-1.293v-8.1A1.3,1.3,0,0,0,185.237,118.878Zm-9.06,0v-1.594a4.012,4.012,0,1,1,7.977,0v1.594Z",
    transform: "translate(-162.686 -104.552)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.65 6.678)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M295.169,305.4h3.207a1.3,1.3,0,0,0,1.293-1.293v-4.066A10.374,10.374,0,0,1,295.169,305.4Z",
    transform: "translate(-286.94 -287.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M192.161,104.408c-2.776,0-5.046,2.53-5.046,5.622v1.56h1.058V110a4.012,4.012,0,1,1,7.977,0v1.594h1.058v-1.56C197.208,106.938,194.937,104.408,192.161,104.408Z",
    transform: "translate(-185.797 -104.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M177.95,216.7H167.808a1.3,1.3,0,0,0-1.293,1.293v8.1a1.3,1.3,0,0,0,1.293,1.293h6.936a10.374,10.374,0,0,0,4.5-5.359v-4.038A1.3,1.3,0,0,0,177.95,216.7Zm-5.071,2.637a1.587,1.587,0,0,1,.6,3.058v2.358h-1.193v-2.358a1.587,1.587,0,0,1,.6-3.058Z",
    transform: "translate(-166.515 -209.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M244.371,259.514a1.587,1.587,0,1,0-2.184,1.471v1.977a3.57,3.57,0,0,0,1.193,0v-1.977A1.587,1.587,0,0,0,244.371,259.514Z",
    transform: "translate(-236.419 -248.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M256.688,336.649v.381h1.193v-.381a3.572,3.572,0,0,1-1.193,0Z",
    transform: "translate(-250.921 -321.795)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldLogo);
export default __webpack_public_path__ + "static/media/shield-logo.ffe8c03ad0ac44546173cc3146366fa3.svg";
export { ForwardRef as ReactComponent };